document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.ac-club').forEach(function (root) {
    var track = root.querySelector('.ac-club__track');
    var prev = root.querySelector('.ac-club__nav--prev');
    var next = root.querySelector('.ac-club__nav--next');
    if (!track) return;

    var isDown = false;
    var startX = 0;
    var scrollStart = 0;

    function cardStep() {
      var card = track.querySelector('.ac-club__card');
      var gap = parseFloat(getComputedStyle(track).gap || 16);
      return card ? card.getBoundingClientRect().width + gap : 300;
    }

    track.addEventListener('mousedown', function (e) {
      isDown = true;
      track.classList.add('is-dragging');
      startX = e.pageX;
      scrollStart = track.scrollLeft;
    });

    ['mouseleave', 'mouseup'].forEach(function (evt) {
      track.addEventListener(evt, function () {
        isDown = false;
        track.classList.remove('is-dragging');
      });
    });

    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      track.scrollLeft = scrollStart - (e.pageX - startX);
    });

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: cardStep(), behavior: 'smooth' });
      });
    }
  });
});